<template v-once>
  <svg viewBox="0 0 4 6" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" :opacity="opacity">
      <g transform="translate(-106, -618)" :fill="fill" fill-rule="nonzero">
        <g transform="translate(32, 592)">
          <g transform="translate(24, 9)">
            <g transform="translate(50, 17)">
              <polygon transform="translate(1.782516, 2.716504) rotate(-270) translate(-1.782516, -2.716504) " points="-0.0951519676 4.49901984 -0.933987201 3.67547219 1.75753485 0.933987201 4.49901984 3.62550925 3.67547219 4.46434449 1.77282243 2.59637009"></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'chevron',
    props: {
      fill: {
        type: String,
        default: '#000000'
      },
      opacity: {
        type: Number,
        default: 0.3
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/svg/Chevron.vue